import { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { selectedProgramContext, getProgramDataForContext } from "features/selected-context";
import CircularLogo from 'components/CircularLogo';
import { useAppSelector } from 'app/hooks';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'app/routes';
import Loading from 'components/Loading';
import SvgIcon from 'components/SvgIcon';

interface Props {
  programContextSelectedId: string;
  programDataIsLoading: boolean;
};

const JobSeekerProgramContextHeader = ({ programContextSelectedId, programDataIsLoading }: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const programData = useAppSelector(selectedProgramContext);

  useEffect(() => {
    if (programContextSelectedId) {
      dispatch(getProgramDataForContext(programContextSelectedId));
    }
  }, [programContextSelectedId, dispatch]);

  return (
    <>
      {programDataIsLoading && <Loading useLayout={false} />}
      <div className="program-context-header-row">
        <div className="header-go-back-col">
          <div className="go-back-button" onClick={() => history.push(`${ROUTES.JOB_SEEKER.EXPLORE_PROGRAMS}`)}>
            <SvgIcon name="back-gray" />
          </div>
        </div>
        <div className="header-logo-col">
          {programData && (programData?.logo || programData.name) ?
            <CircularLogo logo={programData?.logo} name={programData.name} size={75} /> :
            <div className="item-info-logo"><SvgIcon name="logo-no-text" /></div>}
        </div>
        <div className="header-program-info-col">
          {programData && <span className="option-program-name">{programData.name}</span>}
          {!programDataIsLoading && !programData && <span className="option-program-name">Group not found</span>}
        </div>
      </div>
    </>
  );
};

export default JobSeekerProgramContextHeader;
